import { IClickMovingState } from "../types"

export const initialClickMovingState: IClickMovingState = {
  activeBlockId: null,
  activeGapId: null,
  activeGapBlockId: null,
  swappedBlockId: null,
  swappedGapId: null
}

export const DEFAULT_IDLE_TIMEOUT = 60
